/*
This action file conatin the action related to subscription update,fetch subscription etc
*/
import * as api from '../api';

export const FETCH_SUBSCRIPTIONS_REQUEST = 'FETCH_SUBSCRIPTIONS_REQUEST';
export const FETCH_SUBSCRIPTIONS_FAILURE = 'FETCH_SUBSCRIPTIONS_FAILURE';
export const FETCH_SUBSCRIPTIONS_SUCCESS = 'FETCH_SUBSCRIPTIONS_SUCCESS';

export const NOTIFICATION_ADD = 'NOTIFICATION_ADD';

export function fetchAllSubscriptions() {
	
	return function (dispatch, getState) {
		
		dispatch({
			type: FETCH_SUBSCRIPTIONS_REQUEST
		});
		api.fetchSubscriptions().then(
			(response) => {
				dispatch({
					type: FETCH_SUBSCRIPTIONS_SUCCESS,
					subscriptions: response
				});
			},
			(error) => {
				dispatch({
					type: FETCH_SUBSCRIPTIONS_FAILURE,
					text: 'Error fetching subscription.',
					msgtype: 'danger'
				});
			}
		);
	};
}

const FETCH_COMPANY_SUBSCRIPTION_REQUEST='FETCH_COMPANY_SUBSCRIPTION_REQUEST';
const FETCH_COMPANY_SUBSCRIPTION_SUCCESS='FETCH_COMPANY_SUBSCRIPTION_SUCCESS';
const FETCH_COMPANY_SUBSCRIPTION_FAIL='FETCH_COMPANY_SUBSCRIPTION_FAIL';

export function fetchCompanySubscription(company_id){

	return function(dispatch, getState){
	   		dispatch({ type: FETCH_COMPANY_SUBSCRIPTION_REQUEST });
			
			api.companySubscription(company_id).then(
	    	(response) => {
		        dispatch({
		          type: FETCH_COMPANY_SUBSCRIPTION_SUCCESS,
		          subscription: response
		        });
		      },
		      (error) => {
		        dispatch({
		          type: FETCH_COMPANY_SUBSCRIPTION_FAIL,
		          error: error,
		          message: error.message || 'Could not send Messsage to support.'
		        });
		      }
	    );
	};
}

const SELECT_SUBSCRIPTION='SELECT_SUBSCRIPTION';

export function selectSubscription(subscription,upgradeDowngradeText){
	return {
		type: SELECT_SUBSCRIPTION,
		selectedSubscription: subscription,
		upgradeDowngradeText: upgradeDowngradeText
	};
}

export function resetSubscriptionPlan(){
	return {
		type: SELECT_SUBSCRIPTION,
		selectedSubscription: false,
		upgradeDowngradeText: ''
	};
}


const TOGGLE_TNC_ERROR='TOGGLE_TNC_ERROR';

export function toggleTncError(text){
	return {
		type:TOGGLE_TNC_ERROR,
		text:text
	};
}

const SET_COMPANY_SUBSCRIPTION_REQUEST='SET_COMPANY_SUBSCRIPTION_REQUEST';
const SET_COMPANY_SUBSCRIPTION_SUCCESS='SET_COMPANY_SUBSCRIPTION_SUCCESS';
const SET_COMPANY_SUBSCRIPTION_FAIL='SET_COMPANY_SUBSCRIPTION_FAIL';

export function setCompanySubscription(company_id,subscription_id){

	return function(dispatch, getState){
	   		dispatch({ type: SET_COMPANY_SUBSCRIPTION_REQUEST });
			
			api.updateCompanySubscription(company_id,subscription_id).then(
	    	(response) => {
	    				// console.log("response", response)
				        dispatch({
				          	type: SET_COMPANY_SUBSCRIPTION_SUCCESS,
						 	updated: response.requires_action == false,
				  			subscription_id: subscription_id,
				  			sca_data: {
				  				payment_intent_client_secret: response.payment_intent_client_secret,
				  				requires_action: response.requires_action,
				  				message: response.message
				  			}

						});
				        dispatch({
				          type: SET_UPDATE_FROM_FREETRIAL_SUCCESS,
						});
						if(response.requires_action == false){
							dispatch({
								type: NOTIFICATION_ADD,
								text: response.success_msg || 'Subscription Updated.',
								msgtype: 'success'
							});
						}
		      },
		      (error) => {
		        dispatch({
		          type: SET_COMPANY_SUBSCRIPTION_FAIL,
		          error: error,
		          message: error.message || 'Could not update subscription.'
		        });
		        dispatch({
					type: NOTIFICATION_ADD,
					text: error.errorMessage || 'Subscription Updation failed.',
					msgtype: 'danger'
				});
		      }
	    );
	};
}

export function resetCompanySubscription(success = false, success_msg){

	return function(dispatch, getState){
			   
			   if(success){
				dispatch({ 
					type: 'RESET_COMPANY_SUBSCRIPTION_SUCCESS',
					updated: success == true
				  });
				dispatch({
					type: NOTIFICATION_ADD,
					text: success_msg || 'Subscription Updated.',
					msgtype: 'success'
				});
			   }else{
				dispatch({ 
					type: 'FAILED_COMPANY_SUBSCRIPTION_SUCCESS'
				  });
			   }
	};
}

const SUBSCRIPTION_UPDATE='SUBSCRIPTION_UPDATE';

export function setSubscriptionUpdate(status){
	return {
		type:SUBSCRIPTION_UPDATE,
		status:status
	}
}


const SET_UPDATE_FROM_FREETRIAL_REQUEST='SET_UPDATE_FROM_FREETRIAL_REQUEST';
const SET_UPDATE_FROM_FREETRIAL_SUCCESS='SET_UPDATE_FROM_FREETRIAL_SUCCESS';
const SET_UPDATE_FROM_FREETRIAL_FAIL='SET_UPDATE_FROM_FREETRIAL_FAIL';

export function updateFromFreetrial(company_id){

	return function(dispatch, getState){
	   		dispatch({ type: SET_UPDATE_FROM_FREETRIAL_REQUEST });
			
			api.updateFromFreetrial(company_id).then(
	    	(response) => {
		        dispatch({
		          type: SET_UPDATE_FROM_FREETRIAL_SUCCESS,
				});
				dispatch({
					type: NOTIFICATION_ADD,
					text: 'Subscription Updated.',
					msgtype: 'success'
				});
		      },
		      (error) => {
		        dispatch({
		          type: SET_UPDATE_FROM_FREETRIAL_FAIL,
		          error: error,
		          message: error.message || 'Could not update subscription.'
		        });
		      }
	    );
	};
}

const SET_EXTEND_FREETRIAL_REQUEST='SET_EXTEND_FREETRIAL_REQUEST';
const SET_EXTEND_FREETRIAL_SUCCESS='SET_EXTEND_FREETRIAL_SUCCESS';
const SET_EXTEND_FREETRIAL_FAIL='SET_EXTEND_FREETRIAL_FAIL';

export function extendFreetrial(trailend, allowance, company_id, allowChanges){

	return function(dispatch, getState){
	   		dispatch({ type: SET_EXTEND_FREETRIAL_REQUEST });
			
			return api.extendFreetrial(trailend, allowance, company_id, allowChanges).then(
	    	(response) => {
		        dispatch({
		          type: SET_EXTEND_FREETRIAL_SUCCESS,
		          subscriptionAllowanceUpdate: response.allowanceUpdate,

				});
				dispatch({
					type: NOTIFICATION_ADD,
					text: response.message || ' free trail Subscription Updated',
					msgtype: 'success'
				});
		      },
		      (error) => {
		        dispatch({
		          type: SET_EXTEND_FREETRIAL_FAIL,
		          error: error,
		          message: error.message || 'Could not update free trail subscription.'
		        });
		        dispatch({
					type: NOTIFICATION_ADD,
					text: error.message || 'error in update free trail Subscription',
					msgtype: 'danger'
				});
		      }
	    );
	};
}

export const NEW_SUBS_HISTORY_DATA = 'NEW_SUBS_HISTORY_DATA'
export const CURRENT_USER_FETCH_SUCCESS = 'CURRENT_USER_FETCH_SUCCESS'


export function getSubscriptionhistoryData(company_id,activePage){ // to get company trail end date and allowance
	return function(dispatch, getState){
			api.getSubscriptionhistoryData(company_id,activePage).then(
	    	(response) => {
		        dispatch({
		          type: NEW_SUBS_HISTORY_DATA,
		          subs_history_Data: response.subs_data,
				  alljobs: response.jobs_data,
				  allJobsCount: response.count,
				});
		      }
	    );
	};
} 


// WEBPACK FOOTER //
// ./src/Actions/subscriptions.js